.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 26px 20px 0 20px;
}


.header {
  font-size: 20px;
  margin-bottom: 20px;
}

.subHeader {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 24px;
  @include themify($themes) {
    color: themed("neutral-to-primary");
  }
}

.rightSubHeader {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  @include themify($themes) {
    color: themed("main-primary");
  }
  margin-bottom: 8px;
}

.option {
  display: flex;
  margin-bottom: 24px;
}

.optionLabel {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  margin-left: 6px;
}

.container {
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  height: calc(100% - 67px);
}

.containerWrapper {
  overflow-y: auto;
  position: relative;
  height: 100%;
}

.left {
  margin-top: 4px;
  margin-right: 82px;
  flex: 1;
  max-width: 640px;
}

.right {
  margin-top: 4px;
}

.rowRecipients {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: -12px 0 24px 34px;
}

.rowRecipientsLabel {
  font-size: 13px;
  font-weight: 500;
  opacity: 0.7;
}

.rowRecipientsEmpty {
  font-size: 13px;
  opacity: 0.6;
}

.footer {
  padding: 13px 20px;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  position: absolute;
  bottom: 0;
  right: 0;
  @include themify($themes) {
    border-top: 1px solid themed("neutral-secondary");
  }
}

.loading {
  position: relative;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
